import './types';
import './withAnalyticsEvents';

export default (function (channel) {
  return function (payload) {
    return function (createAnalyticsEvent) {
      var consumerEvent = createAnalyticsEvent(payload);
      consumerEvent.clone().fire(channel);
      return consumerEvent;
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/blanket/node_modules/@atlaskit/analytics-next/dist/esm/createAndFireEvent.js
// module id = 784
// module chunks = 0